var _g, _filter, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDayzeLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 579 546",
    height: "47px",
    width: "47px",
    shapeRendering: "auto",
    style: {
      height: "100%",
      width: "100%",
      background: "none",
      shapeRendering: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(1, 1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      transformOrigin: "289.5px 273px",
      transform: "rotate(0deg)",
      animation: "0.653595s linear 0s infinite normal forwards running spin-67a398ce-7af9-4d85-951a-1c7d0d98e4e2"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2672_47)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2672_47)",
    d: "M301.499 504C301.499 382.607 406.936 284.199 537 284.199V42C263.619 42 42 248.844 42 504H301.499Z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }))))))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 546,
    width: 579,
    y: 0,
    x: 0,
    id: "filter0_d_2672_47"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.06 0 0 0 0.59 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_2672_47",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_2672_47",
    in: "SourceGraphic",
    mode: "normal"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 504,
    x2: 289.5,
    y1: 42,
    x1: 289.5,
    id: "paint0_linear_2672_47"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3D5A",
    style: {
      stopColor: "rgb(255, 61, 90)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3D98",
    offset: 1,
    style: {
      stopColor: "rgb(255, 61, 152)"
    }
  }))))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "spin-67a398ce-7af9-4d85-951a-1c7d0d98e4e2",
    "data-anikit": ""
  }, "@keyframes spin-67a398ce-7af9-4d85-951a-1c7d0d98e4e2\n{\n  0% {\n    animation-timing-function: cubic-bezier(0.5856,0.0703,0.4143,0.9297);\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayzeLoader);
export default __webpack_public_path__ + "static/media/dayze-loader.9399eab6cb3fe073fee9be5805f0a89f.svg";
export { ForwardRef as ReactComponent };